class SidebarHoist {

  constructor() {
    // Hoisting
    this.showFirst = document.querySelector('#showFirst');
    this.firstBox = document.querySelector('#trekkspillSidebarFirst');
    this.container = null;
    this.events();
  }

  events() {
    if (this.firstBox) {
      this.container = this.firstBox.parentElement;
      if (window.innerWidth < 992) {
        this.showFirst.appendChild(this.firstBox);
      }

      window.addEventListener('resize', () => {
        if (window.innerWidth < 992) {
          this.showFirst.appendChild(this.firstBox);
        } else {
          this.container.prepend(this.firstBox);
        }
      })

    }


  }
}

export default SidebarHoist

